import api from '@/utils/request'

// 格式化日期时间
function formatDateTime(date) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}

// API接口定义
export const dashboardAPI = {
  // 获取大屏所有数据（真实API）- 支持可扩展参数
  getScreenData(params = {}) {
    return api.get('/screen/index', { params })
  },

  // 获取社区/项目设备信息
  getCommunityInfo(id) {
    return api.get('/screen/community_info', { params: { id } })
  },
  // 获取电梯楼层数据 - 控制电梯开门
  getOpendevice(params = {}) {
    return api.get('/screen/opendevice', { params })
  },
  // 获取维保记录详情
  getRecordInfo(params = {}) {
    return api.get('/screen/recordinfo', { params })
  },
  // 获取事件列表数据
  getEventList(params = {}) {
    return api.get('/screen/eventList', { params })
  },

  // 根据社区名称获取项目列表 - 对接真实接口 /api/screen/community_list
  getProjectListByRegion(params = {}) {
    return api.get('/screen/community_list', { params })
  },
  
  // 对讲请求接口
  voiceIntercom(params = {}) {
    return api.post('/screen/voice', params)
  }
}

export default api